import { TemplateRepository } from "../domain/TemplateRepository";
import { sync_command_dispatcher } from "@/api/client";

export class APITemplateRepository implements TemplateRepository {
  async delete(templateId: number, companyId: number, userId: number): Promise<any> {

    const result = await sync_command_dispatcher.dispatch('delete.template', {
      template_id: templateId,
      company_id: companyId,
      user_id: userId
    });

    return result;
  }
}
